import React, { useState, useEffect } from "react";
import "./NavBar.css";
import logo from "../Assets/Techstrike_logo.png";
import { FaUser, FaTimes, FaBars } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import loginIcon from "../Assets/Login_con.png";
import signupIcon from "../Assets/Signup_con.png";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    setIsLoggedIn(loggedIn);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
    navigate("/");
  };

  return (
    <div className="Navbar">
      <div className="navlogo">
        <img src={logo} alt="logo" width={200} height={150} />

        <div className="menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>

      <ul className={`navbar-menu ${isMenuOpen ? "active" : ""}`}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/Contact">Contact Us</Link></li>
        <li><Link to="/Events">Events</Link></li>
        <li><Link to="/Sub_Pillars">Pillars</Link></li>
        <li><Link to="/announcement">Announcement</Link></li>

        {/* Mobile Auth Links */}
        {!isLoggedIn ? (
          <div className="mobile-auth">
            <Link to="/login">
              <img
                src={loginIcon}
                alt="Login"
                className="nav-icon-img"
              />
            </Link>
            <Link to="/signup">
              <img
                src={signupIcon}
                alt="Sign Up"
                className="nav-icon-img"
              />
            </Link>
          </div>
        ) : (
          <div className="mobile-auth">
            <Link to="/Profile">
              <FaUser className="nav-icon" />
            </Link>
            <button className="signup-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
      </ul>

      {/* Desktop Auth Icons */}
      <div className="nav-icons desktop-only">
        {isLoggedIn ? (
          <>
            <Link to="/Profile">
              <FaUser className="nav-icon" />
            </Link>
            <button className="signup-btn" onClick={handleLogout}>
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login">
              <img
                src={loginIcon}
                alt="Login"
                className="nav-icon-img"
              />
            </Link>
            <Link to="/signup">
              <img
                src={signupIcon}
                alt="Sign Up"
                className="nav-icon-img"
              />
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default NavBar;